import { renderSlot as _renderSlot, vModelDynamic as _vModelDynamic, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6a27a20c"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["type", "placeholder", "name", "disabled", "inputmode"];
const _hoisted_2 = {
  key: 1,
  class: "error-message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_f7_icon = _resolveComponent("f7-icon");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-input-wrap", {
      error: $setup.errorMessage,
      disabled: $props.disabled
    }])
  }, [_renderSlot(_ctx.$slots, "before", {}, undefined, true), _withDirectives(_createElementVNode("input", {
    class: "base-input",
    ref: "inputEl",
    type: $setup.isShowPassword ? 'text' : $props.type,
    placeholder: $props.placeholder,
    name: $props.name,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.value = $event),
    disabled: $props.disabled,
    inputmode: $props.inputmode,
    onBlur: _cache[1] || (_cache[1] = $event => _ctx.$emit('blurEven'))
  }, null, 40, _hoisted_1), [[_vModelDynamic, $setup.value]]), $props.type === 'password' ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    class: "show-password",
    onClick: _cache[2] || (_cache[2] = $event => $setup.isShowPassword = !$setup.isShowPassword)
  }, [_withDirectives(_createVNode(_component_f7_icon, {
    icon: "icon-eyes",
    size: "24px"
  }, null, 512), [[_vShow, !$setup.isShowPassword]]), _withDirectives(_createVNode(_component_f7_icon, {
    icon: "icon-eyes2",
    size: "24px"
  }, null, 512), [[_vShow, $setup.isShowPassword]])])) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default", {}, undefined, true), $setup.errorMessage ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString($setup.errorMessage), 1)) : _createCommentVNode("", true)], 2);
}